import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  UpdateCardPaginationFilters,
  UpdateMemberPaginationFilters,
  UpdatePlaylistPaginationFilters,
} from '@app/app/page-modules/admin/components/members/store/members.action';
import { PaginationFilter } from '@app/app/page-modules/admin/components/members/store/members.state.model';
import { Members, MembersSearchOrder } from '@app/app/shared/models/admin/members.model';
import { AdminMemberTableComponent } from '../admin-member-table/admin-member-table.component';

@Component({
  selector: 'ptl-v3-admin-member-list',
  templateUrl: './v3-admin-member-list.component.html',
  styleUrls: ['./v3-admin-member-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class V3AdminMemberListComponent extends AdminMemberTableComponent {
  @Input() cardUid: string;
  @Input() playlistUid: string;

  @Output() refreshList = new EventEmitter<number>();

  override onPageChangeEvent(event: { currentPage: number; pageSize: number }): void {
    super.onPageChangeEvent(event);
    this.persistPagination();
  }

  override onSizeChange(size: number): void {
    super.onSizeChange(size);
    this.persistPagination();
  }

  override changeListOrdering(orderBy: string): void {
    super.changeListOrdering(orderBy);
    this.persistPagination();
  }

  getMemberInitials(firstName: string, lastName: string): string {
    const first = firstName?.trim().charAt(0) ?? '';
    const last = lastName?.trim().charAt(0) ?? '';
    return (first + last).toUpperCase();
  }

  getRoleLabel(roles: string[]): string {
    return roles?.length ? roles[0] : '';
  }

  isMemberActive(member: Members): boolean {
    const lastActive = member?.lastActiveOn ? new Date(member.lastActiveOn).getTime() : 0;
    if (!lastActive) {
      return false;
    }
    const oneWeekMs = 7 * 24 * 60 * 60 * 1000;
    return Date.now() - lastActive <= oneWeekMs;
  }

  private persistPagination(): void {
    const order: MembersSearchOrder = {
      fieldName: this.defaultOrderBy,
      direction: this.order,
    };
    const paginationFilter: PaginationFilter = {
      page: this.currentPage,
      pageSize: this.pageSize,
      order,
    };

    if (this.isCardPage) {
      this.store.dispatch(new UpdateCardPaginationFilters(this.cardUid, paginationFilter));
    } else if (this.isPlaylistPage) {
      this.store.dispatch(new UpdatePlaylistPaginationFilters(this.playlistUid, paginationFilter));
    } else {
      this.store.dispatch(new UpdateMemberPaginationFilters(paginationFilter));
    }
  }
}
